import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PurchaseVerificationComponent } from './purchase-verification.component';

const routes: Routes = [{ path: '', component: PurchaseVerificationComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PurchaseVerficationRoutingModule { }


